import { Skeleton, Stack } from '@all-manager/design-system-v2';
import type { ActivityTimelineFeed } from "../../../../types";
import DocumentItem from "../../../documents/components/DocumentItem/DocumentItem";
import { useActivityTimelineDocumentsList } from "./useActivityTimelineDocumentsList";

type Props = {
  item: ActivityTimelineFeed;
};

export default function ActivityTimelineDocumentsList(props: Props) {
  const { documents, isLoading } = useActivityTimelineDocumentsList(props);

  if (isLoading) {
    return <Skeleton width={200} height={32} />;
  }

  if (documents.length === 0) {
    return null;
  }

  return (
    <Stack spacing={0.5}>
      {documents.map((doc) => (
        <DocumentItem
          key={doc.id}
          name={doc.name}
          type={doc.type}
          url={doc.file_url}
        />
      ))}
    </Stack>
  );
}
